import { useEffect } from 'react';
import i18n from '@shared/core/i18n/i18n';
import type { TranslationNamespaces } from '@locales/generated';

export const usePreloadTranslationNamespaces = (...namespaces: ReadonlyArray<TranslationNamespaces>) => {
  const stableNamespacesReference = namespaces.join();

  useEffect(() => {
    const loadNamespaces = () => {
      i18n.loadNamespaces(namespaces);
    };

    loadNamespaces();

    i18n.on('languageChanged', loadNamespaces);

    return () => {
      i18n.off('languageChanged', loadNamespaces);
    };
    // The stableNamespacesReference is used to trigger the effect only when the namespaces change
    // Having namespaces as a dependency would cause the effect to run on every render, which is not necessary
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stableNamespacesReference]);
};
